import { Box, Grid, Typography } from "@mui/material";
import React from "react";
import MHButton from "../Common/Button/MHButton";

type Props = {};

const MorganStanleyPress = (props: Props) => {
  return (
    <React.Fragment>
      <Box px={{ xs: 0, sm: 3, md: 10 }} py={{ xs: 2, sm: 10, md: 0 }}>
        <Grid
          container
          sx={{
            borderRadius: "12px",
            position: "relative",
            height: { xs: "fit", sm: "fit", md: "621px" },
            overflow: "hidden",
            bgcolor: "#184049",
          }}
        >
          <Grid item xs={12} sm={12} md={6} lg={5.8}>
            <Box
              className=" z-50"
              sx={{
                pl: { xs: 0, sm: 1, md: 3 },
                py: { xs: 4, sm: 4, md: 0 },
                gap: 2,
                display: "flex",
                flexDirection: "column",
                alignItems: "center",
                alignContent: "center",
                alignSelf: "center",
                justifyContent: "center",
                height: "100%",
              }}
            >
              <Typography
                variant="caption"
                fontSize={{ xs: "10px", sm: "10px", md: "12px" }}
                lineHeight={{ xs: "80%", sm: "189%" }}
                letterSpacing={"0.1em"}
                color={"white"}
                className=" uppercase text-start w-[90%] md:w-[70%] lg:w-[90%] "
              >
                investor highlight
              </Typography>

              <Typography
                variant="h2"
                fontSize={{ xs: "28px", sm: "38px", md: "42px" }}
                lineHeight={{ xs: "103%", sm: "105.5%" }}
                letterSpacing={"-0.05em"}
                color={"white"}
                className="text-start w-[90%] md:w-[70%] lg:w-[90%] "
              >
                Morgan Stanley Backs Caring Africa’s Mission to Transform the
                Care Economy
              </Typography>

              <Typography
                variant="body1"
                fontSize={{ xs: "12px", sm: "14px", md: "14px" }}
                lineHeight={{ xs: "185%", sm: "180%" }}
                letterSpacing={"-0.02em"}
                color={"white"}
                className=" text-start w-[90%] md:w-[70%] lg:w-[90%]"
              >
                Out of thousands of global applicants, Caring Africa was named
                among the 33 organizations selected for the 2025 cohort, and is
                the{" "}
                <b className=" font-areaBlack">
                  {" "}
                  only care tech organization from the African continent.{" "}
                </b>
                <br />
                <br />
                <br />
                Through its flagship digital platform, Caring Blocks, the
                organization is formalizing the continent’s largely informal
                care sector, connecting families to safe, reliable care, while
                providing caregivers with access to training, verification,
                contracts, and fair pay. The platform integrates identity
                authentication, background checks, care payroll, upskilling
                modules, and real-time support to ensure quality care delivery
                across childcare, eldercare, domestic support, and more.
              </Typography>

              <Box className="w-[90%] md:w-[70%] lg:w-[90%]">
                <MHButton
                  onClick={() => window.open("/press-release")}
                  sx={{
                    color: "primary.main", // sets text color
                    backgroundColor: "#fff", // optional
                    borderRadius: "36px",
                    "&:hover": {
                      backgroundColor: "#fff",
                      color: "primary.main", // sets text color
                    },
                  }}
                  className="w-fit md:w-[190px] h-8 md:h-[40px] font-areaExt text-[10px] md:text-xs"
                >
                  View Policy Brief
                </MHButton>
              </Box>
            </Box>
          </Grid>
          <Grid item xs={12} sm={12} md={6} lg={6.2}>
            <img
              src="https://mh-resources-production.s3.us-west-1.amazonaws.com/team.jpg"
              alt="Morgan stanley press release"
              className="md:w-full h-96 mt-30 md:h-full object-cover md:object-cover"
              draggable={false}
            />
          </Grid>
        </Grid>
      </Box>
    </React.Fragment>
  );
};

export default MorganStanleyPress;
